import { AccessibleMedia } from "@components/entries/AccessibleMedia";
import { TextBlockRichText } from "@components/shared/core/TextBlockRichText";
import { QuoteSlide } from "@components/entries/QuotationCarouselSection";
import { FootnoteRichText } from "@components/shared/core/FootnoteRichText";
import { RichText } from "@components/shared/core/RichText";
import { BLOCKS } from "@contentful/rich-text-types";
import cx from "classnames";

export const BlogBodySection = ({items}: any) => {
  if (!items || !items?.length) {
    return <></>;
  }

  const getItem = (item: any) => {
    switch (item.__typename) {
      case 'AccessibleMedia':
        return (
          <div className="my-[60px]">
            <AccessibleMedia item={item} />
          </div>
        )

      case 'SideBySideMedia':
        return (
          <div className="mb-[20px]">
            {(item.mediaCollection?.items.length) > 0 &&
            <>
              {item.title &&
                <h3 className="text-heading-3 text-center max-w-[1280px] text-balance mb-[32px] mx-auto">{item.title}</h3>
              }
              <div className="grid grid-flow-row dsk:grid-flow-col auto-cols-[1fr] gap-[20px]">
                {item.mediaCollection.items.map((media: any) => (
                  <AccessibleMedia key={media.sys?.id} item={media} />
                ))}
              </div>
            </>
            }
          </div>
        )

      case 'CaseStudyInsightsBlockGroup':
        return (
          <div className="insights flex flex-col dsk:flex-row gap-[10px] py-20 justify-center">
            {item.blocksCollection?.items.map((block: any, i: number) => (
              <div
                key={i}
                className={cx('bg-neutral-cream/15 rounded-xl p-8 min-h-[400px] flex flex-col items-start flex-1 border border-brand-black !text-palette-current-highlight', item.blocksCollection.items.length === 1 ? 'max-w-[380px]' : '')}
                style={{ minWidth: 0 }}
              >
                <div className="flex flex-col gap-4 items-start">
                  <FootnoteRichText content={block} options={{
                    renderNode: {
                      [BLOCKS.HEADING_1]: (_, children) => (
                        <p className="text-neutral-dark font-['Netflix_Sans_Title'] font-medium text-[88px] dsk:text-[150px] leading-[0.84] tracking-[-0.03em] capitalize">
                          {children}
                        </p>
                      ),
                      [BLOCKS.PARAGRAPH]: (_, children) => (
                        <p className="text-palette-current-highlight text-body-large max-w-[280px]">
                          {children}
                        </p>
                      )},
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )

      case 'DescriptionFillSection':
        return (
          <div className="max-w-[1014px] my-[60px] mx-auto">
            {item.title &&
              <h3 className="text-heading-3 mb-[32px]">{item.title}</h3>
            }
            {item.descriptionRichText &&
              <TextBlockRichText json={item.descriptionRichText?.json} />
            }
          </div>
        )

      case 'QuotationCarouselItem':
        return (
          <div className="p-0 dsk:p-[60px]">
            <QuoteSlide
              quote={item.quotation ?? ''}
              name={item.attributionName}
              position={item.attributionPosition}
              company={item.attributionCompany}
              variant="line"
            />
          </div>
        )

      case 'RichEntry':
        return (
          <div className="rich-entry max-w-[1014px] my-[60px] mx-auto">
            <RichText content={item} />
          </div>
        )

      default:
        return <></>
    }
  };

  return (
    <div className="blog-body">
      {items.map((item: any) => {
        if (!item) {
          return <></>
        }

        return (
          <div key={item.sys?.id}>
            {getItem(item)}
          </div>
        )})}
    </div>
  );
};
